import React from 'react';
import { BoardEntry } from '../../types';
import { useApp } from '../../context/AppContext';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionTitle from '../ui/SectionTitle';
import { periodo } from '../../data/etiquetas';
import './BoardSection.css';

interface Props {
  boardMemberships: BoardEntry[];
}

const BoardSection: React.FC<Props> = ({ boardMemberships }) => {
  const { t, lang } = useApp();
  const ref = useScrollReveal();

  return (
    <section className="board-section">
      <div
        className="board-section__inner reveal-section"
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        <SectionTitle
          eyebrow={lang === 'es' ? 'Gobierno Corporativo' : 'Corporate Governance'}
          title={lang === 'es' ? 'Experiencia en Consejos' : 'Board Experience'}
        />

        <div className="board-section__grid">
          {boardMemberships.map((b, i) => (
            <div key={i} className="board-card">
              <div className="board-card__role">{t(b.role)}</div>
              <h3 className="board-card__org">{b.organization}</h3>
              <span className="board-card__period">{periodo(b.period, lang)}</span>
              <p className="board-card__desc">{t(b.description)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BoardSection;
